import React from "react"
import { Typography } from "antd"
import styled from "@emotion/styled"
import { theme } from "../../styles/styles"
import { sm } from "../../styles/mediaQuery"
import { getCourse } from "../../lib/prismic/getCourse"
import MultiScheduleCalendar from "../ClassScheduleCalendar/MultiScheduleCalendar"
import { PrismicCourseOrContentfulProduct } from "../../lib/contentful/PrismicCourseOrContentfulProduct"
import { getTechnology } from "../../lib/prismic/mapData"
import moment from "moment"

export const GroupedCoursesByDateIntoCalendar = ({ courses, children }: Props) => {
  return (
    <>
      <Typography.Title level={2}>Otevřené registrace. Online kurzy začínají:</Typography.Title>

      {children || null}

      <MultiScheduleCalendar
        courses={courses.map((p) => {
          const { id, name, courseLessons, firstCourseDay, registerUrl } = getCourse(p)
          const { color } = getTechnology(p)

          return {
            id,
            name,
            color,
            courseDates: courseLessons?.lessonDates?.length > 0 ? courseLessons : { lessonDates: [], skippedDates: [], lastLessonDate: moment() },
            firstCourseDay,
            registrationUrl: registerUrl
          }
        })}
      />
    </>
  )
}

interface Props {
  courses: PrismicCourseOrContentfulProduct[]
  children?: React.ReactNode
}

const DateList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  .ant-badge {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`

const DateCourseItem = styled.li`
  padding: 4px;
  transition: ${theme.effects.transition.default};

  &:hover {
    background-color: ${theme.colors["main-color-blue"]};
    border-radius: 10px;

    .ant-badge-status-text {
      color: whitesmoke;
    }
  }

  .ant-badge {
    font-size: 11px;
    line-height: normal;
    font-variant: normal;
    margin-bottom: 8px;
  }

  .ant-badge-status-text {
    font-size: 11px;
    line-height: 0.8;
    word-spacing: -2px;
  }
`

const DateItemCourseCardWrapper = styled.div`
  max-width: 20vw;
  margin: -12px -16px;

  ${sm} {
    max-width: initial;
    width: 60vw;
  }
`
